/* eslint-disable prefer-template */
<template>
  <div class="user-management">
    <div class="search-form">
      <el-form
        inline
        :model="originData"
        :rules="searchRules"
        ref="searchForm"
      >
        <el-form-item
          label="姓名:"
          prop="userName"
        >
          <el-input
            onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"
            placeholder="请输入姓名"
            v-model.trim="originData.userName"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="手机号:"
          prop="phone"
        >
          <el-input
            placeholder="请输入线索手机号"
            v-model.trim="originData.phone"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户状态:">
          <el-select
            placeholder="请选择客户状态"
            v-model="originData.saleStatus"
            clearable
          >
            <el-option
              v-for="item in custStatus"
              :key="item.id"
              :label="item.status"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="分配状态:">
          <el-select
            clearable
            placeholder="请选择分配状态"
            v-model="originData.assignStatus"
          >
            <el-option
              v-for="item in distStatus"
              :key="item.id"
              :label="item.status"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="创建日期:"
          class="date-container"
        >
          <el-date-picker
            v-model="originData.createTimeStartTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
          ></el-date-picker>&nbsp;&nbsp;至&nbsp;&nbsp;
          <el-date-picker
            v-model="originData.createTimeEndTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="是否有未执行电访计划:"
          prop="userName"
        >
          <el-select
            clearable
            v-model="originData.isUnExecutePlan"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最后电访时间:">
          <el-date-picker
            style="width: 200px;"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :default-time="'00:00:00'"
            v-model="originData.lastContactStartTime"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>至
          <el-date-picker
            style="width: 200px;"
            :default-time="'23:59:00'"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            v-model="originData.lastContactEndTime"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="归属机构:"
          class="date-container"
        >
          <el-autocomplete
            :trigger-on-focus="false"
            class="inline-input"
            v-model="originData.ownerOrganization"
            :fetch-suggestions="querySearchOrgan"
            placeholder="请输入机构名称"
            @select="handleSelectOrgan"
          ></el-autocomplete>

        </el-form-item>
      </el-form>
    </div>
    <div class="flex-between">
      <div>
        <el-button
          size="small"
          type="primary"
          @click="handleQueryClick"
        >查询</el-button>
        <el-button
          size="small"
          @click="reset"
        >清空查询条件</el-button>
      </div>
      <div>
        <el-button
          size="small"
          v-if="functionList.indexOf(
          '322225218357268480')!='-1'"
          @click="developLiaisonPlans(0)"
        >批量制定联络计划</el-button>
        <el-button
          size="small"
          @click="addTask('1')"
          v-if="functionList.indexOf(
          '321181694413213696')!='-1'"
        >新增线索（管理员）</el-button>
        <el-button
          size="small"
          @click='distributeLeads'
          v-if="functionList.indexOf(
          '321181953579257856')!='-1'"
        >分配线索</el-button>
        <el-button
          size="small"
          @click="addTask('2')"
          v-if="functionList.indexOf(
          '321182278189027328')!='-1'"
        >新增线索</el-button>
      </div>
    </div>
    <div class="user_table">
      <el-table
        ref="table"
        :default-sort="{prop: '[lastContactTime,planedContactTime]', order: 'descending'}"
        highlight-current-row
        :data="tableData"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
      >
        <template slot="empty">
          {{emptyText}}
        </template>
        <el-table-column
          type="selection"
          name="选择"
          width="30"
        >
        </el-table-column>
        <el-table-column
          label="线索ID"
          width="200"
        >
          <template slot-scope="scope">
            {{scope.row.id}}
          </template>
        </el-table-column>
        <el-table-column
          prop="userName"
          label="姓名"
          width="120"
        >
          <template slot-scope="scope">
            <span
              class='leadDetail'
              @click="getDetail(scope.row)"
              v-html='scope.row.userName'
            >
            </span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="130"
          label="手机号"
        >
          <template slot-scope="scope">
            {{scope.row.phone | encryptPhone| blankValue}}
          </template>
        </el-table-column>
        <el-table-column
          prop="ownerOrganizationName"
          label="归属机构"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="customerManager"
          label="客户经理姓名"
          width="120"
        >
          <template slot-scope="scope">
            <span>{{scope.row.customerManager}}</span>
            <span>{{scope.row.customerManagerWorkNo}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="assignStatus"
          label="分配状态"
          width="120"
        >
          <template slot-scope="scope">
            <span>
              <span v-if="parseInt(scope.row.assignStatus)==1">未分配</span>
              <span v-if="parseInt(scope.row.assignStatus)==2">已分配</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="saleStatus"
          label="客户状态"
          width="100"
        >
          <template slot-scope="scope">
            <span>
              <span v-if="parseInt(scope.row.saleStatus)==1">线索客户</span>
              <span v-if="parseInt(scope.row.saleStatus)==2">已转化</span>
              <span v-if="parseInt(scope.row.saleStatus)==3">无效客户</span>
            </span>
            <!-- {{scope.row.saleStatus}} -->
            <el-dropdown
              v-if="functionList.indexOf(
          '321182731526180864')!='-1'"
              @command="(v)=>{handleCommand(v, scope.row)}"
            >
              <i class="el-icon-edit-outline"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="item in filterCustomerList(customerStatusList, scope.row.saleStatus)"
                  :key="item.id"
                  :command="item.id"
                >{{item.name}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          width="200"
        >
          <template slot-scope="scope">{{scope.row.remark | blankValue}}</template>
        </el-table-column>
        <el-table-column
          label='创建时间'
          width="200"
        >
          <template slot-scope="scope">
            {{scope.row.createTime | formatTime}}
          </template>
        </el-table-column>
        <el-table-column
          label='最后电访时间'
          prop="lastContactTime"
          width="200"
          sortable="custom"
          :sort-orders="['descending','ascending',null]"
        >
          <template slot-scope="scope">
            {{scope.row.lastContactTime | formatTime}}
          </template>
        </el-table-column>
        <el-table-column
          label='最新计划电访时间'
          prop="planedContactTime"
          width="200"
          sortable="custom"
          :sort-orders="['descending','ascending',null]"
        >
          <template slot-scope="scope">
            {{scope.row.planedContactTime | formatTime}}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="270px"
        >
          <template slot-scope="scope">
            <div class="feature-container">
              <span
                class="span_handle"
                @click="editTask(scope.row)"
                type="primary"
                v-if="functionList.indexOf(
          '321182731526180864')!='-1'"
              >修改</span>
              <span
                class="span_handle"
                style="margin-left: 5px"
                @click="developLiaisonPlans(1,scope.row)"
                v-if="functionList.indexOf(
          '322225758235496448')!='-1'"
              >制定联络计划</span>
              <span
                class="span_handle"
                style="margin-left: 5px"
                @click="showCallPlan(scope.row)"
                v-if="functionList.indexOf(
          '322637833881489408')!='-1'"
              >查看联络计划</span>
              <span
                v-if="functionList.indexOf(
          '321182903391981568')!='-1'"
                class="span_point"
                @click='handleDelBtnClick(scope.row)'
                type="danger"
              >删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
    <yh-dialog
      title="分配线索"
      :close-on-click-modal="false"
      :visible.sync="shouldShowPassDialog"
      width="35%"
    >
      <el-form
        label-width="80px"
        ref="leadForm"
        :rules="rules"
        :model="leadForm"
      >
        <el-form-item>
          <span class="spespan">将选中的{{this.leadsLength}}条线索分配给</span>
        </el-form-item>
        <el-form-item prop="customerManager">
          <el-autocomplete
            class="inline-input"
            v-model="leadForm.customerManager"
            :fetch-suggestions="querySearch"
            placeholder="请输入"
            @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item
          label="备注:"
          prop="operationDesc"
        >
          <el-input
            type="textarea"
            v-model="leadForm.operationDesc"
            placeholder="请输入备注，不超过200字"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="shouldShowPassDialog = false">取消</el-button>
        <el-button
          type="primary"
          @click="handleGiveLeads"
        >确认</el-button>
      </div>
    </yh-dialog>
    <!--    制定联络计划-->
    <yh-dialog
      title="制定联络计划"
      :visible.sync="liaisonPlanDialog"
    >
      <el-form
        inline
        class="hide-error"
        ref="liaisonForm"
        :rules="liaisonrules"
        :model="liaisonForm"
      >
        <el-form-item
          label="联络方式:"
          prop="operationDesc"
        >
          <el-radio
            v-model="liaisonForm.contactType"
            label="1"
          >电访</el-radio>
        </el-form-item>
        <div v-if="this.status==1">
          <el-form-item
            label="客户姓名:"
            prop="operationDesc"
          >
            <el-input
              v-model="liaisonForm.customerName"
              disabled
            ></el-input>
          </el-form-item>

          <el-form-item
            label="手机号:"
            prop="operationDesc"
          >
            <el-input
              v-model="liaisonForm.phone"
              disabled
            ></el-input>
          </el-form-item>

        </div>
        <el-form-item
          label="电访时间:"
          prop="planTime"
          required
        >
          <el-date-picker
            clearable
            v-model="liaisonForm.planTime"
            type="datetime"
            placeholder="选择日期时间"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="电访目标:"
          prop="operationDesc"
        >
          <el-select
            clearable
            v-model="liaisonForm.contactObjective"
            placeholder="请选择"
          >
            <el-option
              v-for="item in calloptions"
              :key="item.dictValue"
              :label="item.dictName"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="备注:"
          prop="operationDesc"
        >
          <el-input
            type="textarea"
            v-model="liaisonForm.remark"
            placeholder="请输入备注，不超过200字"
          ></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer">
        <el-button @click="liaisonPlanDialog = false">取消</el-button>
        <el-button
          type="primary"
          @click="liaisonConfirmBatch()"
          v-if="this.status==0"
        >确认</el-button>
        <el-button
          type="primary"
          @click="liaisonConfirm()"
          v-if="this.status==1"
        >确认</el-button>
      </div>
    </yh-dialog>
    <Yh-lead-detail :dialog="dialog"></Yh-lead-detail>
  </div>
</template>
<script>
import { getFunctionList, addNav, getPagingData } from '@/mixins';
import YhLeadDetail from './detail.vue';

export default {
  name: 'LeadTable',
  components: {
    YhLeadDetail,
  },
  mixins: [getFunctionList, addNav, getPagingData],

  data() {
    const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    // 联络客户校验
    function validatorTime(rule, value, callback) {
      console.log('电访时间', value);
      if (value === undefined || value === '') {
        callback(new Error('电访时间不为空'));
      } else {
        callback();
      }
    }
    // 查询条件输入校验
    function validateUserName(rule, value, callback) {
      if (value.length >= 20) {
        callback(new Error('姓名最多输入20个字符'));
      } else {
        callback();
      }
    }
    function validatePhone(rule, value, callback) {
      if (value.length >= 20) {
        callback(new Error('手机号最多输入20个字符'));
      } else {
        callback();
      }
    }
    // 分配线索输入校验
    function validateMana(rule, value, callback) {
      if (!value) {
        callback(new Error('请选择客户经理！'));
      } else if (value && value.length >= 20) {
        callback(new Error('最多输入20个字符'));
      } else {
        callback();
      }
    }
    function validateMark(rule, value, callback) {
      if (value && value.length > 200) {
        callback(new Error(this.$MSG.M0022));
      } else {
        callback();
      }
    }
    return {
      // 机构下拉框
      ascriptionOrgan: [],
      ownerOrganization: '',
      // 制定联络计划弹框分支
      liaisonForm: {
        contactResourceId: '', // 联系客户id
        contactType: '1', // 联络方式
        customerName: '', // 客户姓名
        phone: '', // 手机号
        planTime: '', // 电访时间
        contactObjective: '', // 电访目标
        remark: '', // 备注
      },
      // 批量还是单个的状态
      status: '',
      // 批量制定联络计划
      liaisonPlanDialog: false,
      // 是否执行电访计划
      options: [
        {
          value: '1',
          label: '是',
        },
        {
          value: '0',
          label: '否',
        },
      ],
      leadForm: {
        customerManager: '',
        operationDesc: '',
      },
      // 初始数据
      originData: {
        userName: '',
        phone: '',
        saleStatus: '',
        assignStatus: '',
        createTimeStartTime: '',
        createTimeEndTime: '',
        isUnExecutePlan: '',
        lastContactStartTime: '',
        lastContactEndTime: '',
        ownerOrganization: '',
        ownerOrganizationId: '',
      },
      // 查询数据
      searchParam: {
        userName: '',
        phone: '',
        saleStatus: '',
        assignStatus: '',
        createTimeStartTime: '',
        createTimeEndTime: '',
        lastContactStartTime: '',
        lastContactEndTime: '',
        isUnExecutePlan: '',
        ownerOrganization: '',
        ownerOrganizationId: '',
      },
      dialog: {
        show: false,
        detailId: '',
        activeName: '',
        getName: '',
        leadsData: [],
        pName: '',
        cName: '',
        aName: '',
        apName: '',
        acName: '',
        aaName: '',
      },
      managerList: [],
      customerManager: '',
      operationDesc: '',
      showdia: false,
      customerStatusList: [
        {
          id: 1,
          name: '线索客户',
        },
        {
          id: 2,
          name: '已转化',
        },
        {
          id: 3,
          name: '无效客户',
        },
      ],
      // 联络客户校验
      liaisonrules: {
        planTime: [{ validator: validatorTime }],
      },
      // 查询条件的校验
      searchRules: {
        userName: [{ validator: validateUserName }],
        phone: [{ validator: validatePhone }],
      },
      // 分配线索的校验
      rules: {
        customerManager: [
          // { required: true, message: '请选择客户经理！' },
          { validator: validateMana, trigger: 'change' },
        ],
        operationDesc: [{ validator: validateMark }],
      },

      shouldShowPassDialog: false,
      // 创建日期排序 默认 正序 倒序
      createSort: 0,
      updateSort: 1,
      // 表格数据
      tableData: [],
      // 功能集合
      functionList: [],
      // 总数
      sumCount: 0,
      // 当前页数
      currentPage: 1,
      // 每页数量
      pageSize: 10,
      // 相关用户数据
      orgnCode: sessionData.orgnCode,
      orgnName: sessionData.orgnName,
      roleName: '',
      calloptions: [],
      orgnTreeDialog: false,
      props1: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf',
      },
      // 机构树选中的对象
      orgn: {
        name: sessionData.orgnName,
        orgnCode: sessionData.orgnCode,
      },
      custStatus: [
        {
          id: 1,
          status: '线索客户',
        },
        {
          id: 2,
          status: '已转化',
        },
        {
          id: 3,
          status: '无效客户',
        },
      ],
      distStatus: [
        {
          id: 1,
          status: '未分配',
        },
        {
          id: 2,
          status: '已分配',
        },
      ],
      selectLead: [],
      leadsLength: '',
      selectedLeadIds: [],
      customerId: '',
      sortOrder: '', // 排序
    };
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.searchParam = { ...this.originData, orderType: this.sortOrder };
        this.getTableData();
      },
    },
    $route(to, from) {
      if (from.path === '/addLead' || from.path === '/editLead') {
        this.getTableData();
      }
    },
    shouldShowPassDialog() {
      this.$nextTick(() => this.$refs.leadForm.clearValidate());
    },
  },
  mounted() {
    // 归属机构
    this.loadAll();
    // 电访目标下拉字典值
    this.selectCallTarget();
    //
  },
  methods: {
    // 电访目标下拉字典值
    selectCallTarget() {
      const params = {
        data: {
          dictTypeCode: 'callTarget',
          status: '2',
        },
      };
      this.$_post(this.$API.selectDict, params)
        .then((res) => {
          if (res.errorCode === this.$CODE.success) {
            console.log('电访目标下拉字典值', res.data.list);
            this.calloptions = res.data.list;
          }
        })
        .catch(() => {});
    },
    // 列表字段排序
    sortChange(column) {
      const sortMap = {
        lastContactTimedescending: '2',
        lastContactTimeascending: '1',
        planedContactTimedescending: '4',
        planedContactTimeascending: '3',
      };
      this.sortOrder = sortMap[column.prop + column.order];
      this.searchParam = { ...this.originData, orderType: this.sortOrder };
      this.getTableData();
    },
    handleSelectOrgan(item) {
      this.originData.ownerOrganizationId = item.label;
    },
    loadAll() {
      const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
      const params = {
        data: {
          orgnCode: sessionData.orgnCode,
        },
      };
      this.$_post(this.$API.subOrganizationsSearch, params)
        .then((res) => {
          if (res.errorCode === this.$CODE.success) {
            this.ascriptionOrgan = res.data.list;
          }
        })
        .catch(() => {});
    },
    querySearchOrgan(queryString, cb) {
      const results = queryString
        ? this.ascriptionOrgan.filter(this.createFilterOrgan(queryString))
        : this.ascriptionOrgan;
      // 调用 callback 返回建议列表的数据
      cb(this.result(results));
    },
    result(results) {
      const arr = [];
      results.forEach((item) => {
        if (arr.length < 10) {
          arr.push({
            value: item.orgnName,
            label: item.orgnCode,
          });
        }
      });
      return arr;
    },
    createFilterOrgan(queryString) {
      return restaurant => restaurant.orgnName.toLowerCase().includes(queryString.toLowerCase());
    },

    // 分配线索下拉数据筛选
    querySearch(queryString, cb) {
      const results = queryString
        ? this.managerList.filter(this.createFilter(queryString))
        : this.managerList;
      cb(this.set(results));
    },
    set(results) {
      const arr = [];
      results.forEach((item) => {
        arr.push({
          value: item.userName + item.workNo,
          label: item.id,
        });
      });
      return arr;
    },
    createFilter(queryString) {
      return restaurant => (restaurant.userName + restaurant.workNo)
        .toLowerCase()
        .includes(queryString.toLowerCase());
    },
    // 选择（单/多选）
    handleSelectionChange(sels) {
      // var ids= this.selectPrd.map(item => item.ID).join()
      this.selectLead = sels;
    },
    // 选择理财经理
    handleSelect(item) {
      // console.log('sdfdfdfdbf', item);
      this.customerId = item.label;
    },
    // 更改列表的客户状态
    handleCommand(status, row) {
      const parames = {
        data: {
          id: row.id,
          saleStatus: status,
        },
      };
      this.$_post(this.$API.leadEdit, parames)
        .then((res) => {
          if (res.errorCode === this.$CODE.success) {
            this.$message.success('修改成功!');
            this.getTableData();
          } else {
            this.$message.error('修改失败!');
          }
        })
        .catch(() => {
          this.$message.error('修改失败！');
        });
    },
    // 客户状态下拉筛选
    filterCustomerList(list, status) {
      return list.filter(item => item.id !== parseInt(status, 10));
    },
    // 查询按钮
    handleQueryClick() {
      this.$refs.table.clearSort();
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.searchParam = { ...this.originData, orderType: this.sortOrder };
          if (this.searchParam.ownerOrganization) {
            if (
              this.searchParam.ownerOrganization
              && this.searchParam.ownerOrganizationId
            ) {
              this.pageNo = 1;
              this.getTableData();
              this.originData.ownerOrganizationId = '';
            } else {
              this.$message.warning('请从匹配结果中选择归属机构');
            }
          } else {
            this.sortOrder = '';
            this.createSort = 0;
            this.updateSort = 0;
            this.pageNo = 1;
            this.getTableData();
          }
        }
      });
    },
    // 重置按钮
    reset() {
      this.ownerOrganization = '';
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
    },
    // 获取表格数据
    getTableData() {
      this.getPagingData(this.$API.leadListQuery).then(() => {
        console.log('表格数据', this.tableData);
      });
    },
    //  从线索姓名获取详情弹出框
    getDetail(item) {
      // 重置省
      if (item.residenceProvinceCode) {
        this.getProvinceList(item.residenceProvinceCode);
      }
      if (item.addressProvinceCode) {
        this.getAdrProvinceList(item.addressProvinceCode);
      }
      // 重置市
      if (item.residenceCityCode) {
        this.getCityList(item.residenceCityCode, item.residenceProvinceCode);
      }
      if (item.addressCityCode) {
        this.getAdrCityList(item.addressCityCode, item.addressProvinceCode);
      }
      // 重置区
      if (item.residenceDistrictCode) {
        this.getAreaList(item.residenceDistrictCode, item.residenceCityCode);
      }
      if (item.addressDistrictCode) {
        this.getAdrAreaList(item.addressDistrictCode, item.addressCityCode);
      }
      this.dialog.show = true;
      this.dialog.activeName = 'first';
      this.dialog.getName = item.userName;
      this.dialog.detailId = item.id;
      this.dialog.leadsData = [item];
    },
    // 删除按钮
    handleDelBtnClick(item) {
      this.$_yh_confirm('确定删除该条线索客户?').then(() => {
        this.deleteLead(item);
      });
    },
    // 线索删除
    deleteLead(item) {
      const parames = {
        data: {
          id: item.id,
        },
      };
      return this.$_post(this.$API.leadDelete, parames).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message({
            message: '删除成功',
            type: 'success',
          });
          this.getTableData();
        } else {
          this.$message({
            message: res.errorMsg,
            type: 'warning',
          });
        }
      });
    },
    // 分配线索
    distributeLeads() {
      if (this.selectLead.length === 0) {
        this.$message({
          message: '请选择线索',
          type: 'warning',
        });
      } else {
        this.leadForm.customerManager = '';
        this.leadForm.operationDesc = '';
        this.shouldShowPassDialog = true;
        this.leadsLength = this.selectLead.length;
        this.getManager();
      }
    },
    // 获取当前机构所有理财经理
    getManager() {
      const params = {
        data: {
          orgnCode: JSON.parse(sessionStorage.getItem('sessionData')).orgnCode,
        },
      };
      return this.$_post(this.$API.getPresentManagers, params).then((res) => {
        this.managerList = res.data.list;
      });
    },
    // 分配线索确认
    handleGiveLeads() {
      this.$refs.leadForm.validate((valid) => {
        if (valid) {
          this.selectLead.forEach((item) => {
            this.selectedLeadIds.push(item.id);
          });
          const params = {
            data: {
              salesLeadList: this.selectedLeadIds,
              customerManagerId: this.customerId,
              operationDesc: this.leadForm.operationDesc,
            },
          };
          if (this.customerId) {
            this.$_post(this.$API.leadDistribute, params).then((res) => {
              if (res.errorCode === this.$CODE.success) {
                this.$message.success(res.errorMsg);
                this.shouldShowPassDialog = false;
                this.selectedLeadIds = [];
                this.getTableData();
                this.customerId = '';
              } else {
                this.$message.error('分配线索失败!');
              }
            });
          } else {
            this.$message.warning('没有匹配到客户经理');
          }
        }
      });
    },
    // 点击新增(1为管理员新增，2为经理新增)
    addTask(addLevel) {
      this.addNav({
        name: '新增线索',
        path: '/addLead',
      });
      sessionStorage.setItem('addLevel', addLevel);
    },
    // 点击修改
    editTask(row) {
      this.addNav({
        name: '修改线索',
        path: '/editLead',
      });
      sessionStorage.setItem('ID', row.id);
      sessionStorage.setItem('detailData', JSON.stringify(row));
    },
    // 制定联络计划
    developLiaisonPlans(status, info) {
      Object.keys(this.liaisonForm).forEach((key) => {
        this.liaisonForm[key] = '';
      });
      this.status = status;
      this.liaisonForm.contactType = '1';
      if (info !== undefined) {
        this.liaisonForm.contactResourceId = info.id;
        this.liaisonForm.phone = info.phone;
        this.liaisonForm.customerName = info.userName;
      }
      // status 0-批量 1-单个
      let flag = false;
      if (status === 0) {
        this.selectLead.forEach((e) => {
          if (e.phone === undefined) {
            flag = true;
          }
        });
        if (flag === false) {
          if (this.selectLead.length === 0) {
            this.$message({
              message: '请至少选择一条数据',
              type: 'warning',
            });
          } else {
            // 后台接口
            this.liaisonPlanDialog = true;
          }
        } else {
          this.$message({
            message: '只能选择有手机号的线索',
            type: 'warning',
          });
        }
      }
      if (status === 1) {
        if (info.phone === undefined) {
          this.$message({
            message: '只能选择有手机号的线索',
            type: 'warning',
          });
        } else {
          // 后台接口
          this.liaisonPlanDialog = true;
        }
      }
    },
    // 制定校验
    checkFormData(handleName) {
      console.log('liaisonFormliaisonForm', this.liaisonForm);
      function checkDateTime() {
        return (v) => {
          const timestamp = new Date().getTime();
          const value = new Date(v).getTime();
          if (value < timestamp) {
            return false;
          }
          return true;
        };
      }
      const rules = [
        {
          prop: 'planTime',
          message: '请选择电访时间',
          validations: [
            {
              message: '请选择正确的日期和时间',
              validate: checkDateTime(),
            },
          ],
        },
      ];
      return rules.every((rule) => {
        const data = String(this[handleName][rule.prop]).trim();
        if (!data) {
          this.$message.warning(rule.message);
          return false;
        }
        if (this[handleName].remark && this[handleName].remark.length > 200) {
          this.$message.warning(this.$MSG.M0027);
          return false;
        }
        const { validations } = rule;
        if (validations) {
          return validations.every((validation) => {
            if (!validation.validate(data)) {
              this.$message.warning(validation.message);
              return false;
            }
            return true;
          });
        }
        return true;
      });
    },
    // 确定制定联络计划
    liaisonConfirm() {
      if (!this.checkFormData('liaisonForm')) {
        return;
      }
      const parames = {
        data: {
          contactResourceId: this.liaisonForm.contactResourceId,
          contactType: this.liaisonForm.contactType,
          customerName: this.liaisonForm.customerName,
          customerType: 'salesLeadCustomer',
          phone: this.liaisonForm.phone,
          planTime: this.liaisonForm.planTime,
          contactObjective: this.liaisonForm.contactObjective,
          remark: this.liaisonForm.remark,
        },
      };
      this.$_post(this.$API.createLeadPlan, parames)
        .then((res) => {
          if (res.errorCode === this.$CODE.success) {
            this.$message.success(this.$MSG.M0108);
            this.liaisonPlanDialog = false;
            this.getTableData();
          } else {
            this.$message.error('制定失败!');
          }
        })
        .catch(() => {
          this.$message.error('制定失败！');
        });
    },
    // 确定制定联络计划批量
    liaisonConfirmBatch() {
      if (!this.checkFormData('liaisonForm')) {
        return;
      }
      const arr = [];
      this.selectLead.forEach((e) => {
        arr.push({
          id: e.id,
          customerName: e.userName,
          phone: e.phone,
        });
      });
      const parames = {
        data: {
          contactList: arr,
          contactType: this.liaisonForm.contactType,
          customerName: this.liaisonForm.customerName,
          customerType: 'salesLeadCustomer',
          phone: this.liaisonForm.phone,
          planTime: this.liaisonForm.planTime,
          contactObjective: this.liaisonForm.contactObjective,
          remark: this.liaisonForm.remark,
        },
      };
      this.$_post(this.$API.contactTelPlans, parames)
        .then((res) => {
          if (res.errorCode === this.$CODE.success) {
            this.$message.success('成功!');
            this.liaisonPlanDialog = false;
            this.getTableData();
          } else {
            this.$message.error('失败!');
          }
        })
        .catch(() => {
          this.$message.error('失败！');
        });
    },
    // 查看联络计划
    showCallPlan(row) {
      this.addNav({
        name: '电访计划',
        path: '/call-plan',
        query: row,
      });
    },
    // 省
    getProvinceList(pCode) {
      const parames = {
        data: {
          parentId: '000000',
        },
      };
      return this.$_post(`${this.$API.adressGet}?v=1`, parames).then((res) => {
        res.data.list.forEach((item) => {
          if (item.provinceId === pCode) {
            this.dialog.pName = item.provinceName;
          }
        });
      });
    },
    getAdrProvinceList(pCode) {
      const parames = {
        data: {
          parentId: '000000',
        },
      };
      return this.$_post(`${this.$API.adressGet}?v=2`, parames).then((res) => {
        res.data.list.forEach((item) => {
          if (item.provinceId === pCode) {
            this.dialog.apName = item.provinceName;
          }
        });
      });
    },
    // 市
    getCityList(pCode, parentId) {
      const parames = {
        data: {
          parentId,
        },
      };
      return this.$_post(`${this.$API.adressGet}?v=3`, parames).then((res) => {
        res.data.list.forEach((item) => {
          if (item.provinceId === pCode) {
            this.dialog.cName = item.provinceName;
          }
        });
      });
    },
    getAdrCityList(pCode, parentId) {
      const parames = {
        data: {
          parentId,
        },
      };
      return this.$_post(`${this.$API.adressGet}?v=4`, parames).then((res) => {
        res.data.list.forEach((item) => {
          if (item.provinceId === pCode) {
            this.dialog.acName = item.provinceName;
          }
        });
      });
    },
    // 区
    getAreaList(pCode, parentId) {
      const parames = {
        data: {
          parentId,
        },
      };
      return this.$_post(`${this.$API.adressGet}?v=5`, parames).then((res) => {
        res.data.list.forEach((item) => {
          if (item.provinceId === pCode) {
            this.dialog.aName = item.provinceName;
          }
        });
      });
    },
    getAdrAreaList(pCode, parentId) {
      const parames = {
        data: {
          parentId,
        },
      };
      return this.$_post(`${this.$API.adressGet}?v=6`, parames).then((res) => {
        res.data.list.forEach((item) => {
          if (item.provinceId === pCode) {
            this.dialog.aaName = item.provinceName;
          }
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
// .datestyle {
//   margin-left: 40px;
// }
.leadDetail {
  color: #54a6de;
  cursor: pointer;
}
.el-tabs__content {
  height: 400px;
  overflow: auto;
}
.spespan {
  margin-left: -42px;
}
.el-textarea {
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #f5f7fa;
  }
}
.search_input {
  width: 100%;
}
.search_input .el-col {
  margin-top: 10px;
}
// .el-form-item {
// height: 20px;
// margin-left: 10%;
// }
.span_handle {
  color: #409eff;
  cursor: pointer;
  margin-left: 10px;
}
.span_point {
  color: #f56c6c;
  cursor: pointer;
  margin-left: 10px;
}
// .el-date-editor.el-input,
// .el-date-editor.el-input__inner {
//   width: 37.2% !important;
//   margin-left: 8px;
// }
.search_bottom {
  margin-top: 20px;
}
.btn_foot {
  padding: 10px 16px;
}
.btn_foot_save {
  padding: 10px 16px;
  background-color: #54a6de;
  color: #fff;
}

.button-container {
  display: flex;
  justify-content: center;
  padding: 30px 0 0;
}
.date-container .el-input {
  width: calc(50% - 20px);
}
</style>
<style lang="scss">
.search_input .el-form-item.is-success .el-input__inner {
  border-color: #dcdfe6;
}
</style>
